import {SubscribedComponent} from "../../subscribed.component";
import {Component, Input} from "@angular/core";
import {NbComponentOrCustomStatus, NbComponentSize, NbFormControlState} from "@nebular/theme";

@Component({
    template: '',
    standalone: false
})
export abstract class StyledBaseComponent extends SubscribedComponent implements NbFormControlState{

  @Input() size: NbComponentSize = 'medium';
  @Input() status: NbComponentOrCustomStatus = 'basic';
  @Input() placeholder: string = null;
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() maxlength: number = null;
  @Input() focused: boolean = false;

}
